var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrolldown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 42,
    viewBox: "0 0 23 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.9965 2.37575C6.06224 2.61873 2.13627 6.69632 2.13627 11.6909V30.344C2.13627 35.4949 6.31192 39.6706 11.4628 39.6706C16.6138 39.6706 20.7894 35.4949 20.7894 30.344V11.6909C20.7894 6.69632 16.8634 2.61873 11.9292 2.37575V15.4215H10.9965V2.37575ZM11.9292 1.44205C17.3787 1.68584 21.7221 6.18114 21.7221 11.6909V30.344C21.7221 36.01 17.1289 40.6032 11.4628 40.6032C5.79683 40.6032 1.20361 36.01 1.20361 30.344V11.6909C1.20361 6.18114 5.54694 1.68584 10.9965 1.44205V1.43164H11.9292V1.44205Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrolldown);
export default __webpack_public_path__ + "static/media/scroll down.339842411c65ac89b458a8acd6458620.svg";
export { ForwardRef as ReactComponent };